/** Motion policy. `prefers-reduced-motion: reduce` turns transitions into plain fades. */
export function reducedMotion(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}
